/**
 * Created by hp on 2017/8/21.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Page} from '../components';
import {RelaySettingLectureList, RelaySettingChannelList} from '../components/relaySetting';
import '../css/page/RelaySettingListPage.css';

class RelaySettingListPage extends Component {
    componentWillMount() {
        const {id} = this.props.params;
        this.props.dispatch({type: 'RELAY_SETTING_LIST_ID_INIT', payload: parseInt(id, 10)});
    }

    render() {
        const {type} = this.props.params;

        return (
            <Page parent={this}>
                <div className="wk-inner-page">
                    {type === 'lecture' &&
                    <RelaySettingLectureList/>
                    }

                    {type === 'channel' &&
                    <RelaySettingChannelList/>
                    }
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({

}))(RelaySettingListPage);


// WEBPACK FOOTER //
// ./src/pages/RelaySettingListPage.js